import ApiService from "@/utils/request"

export const guestServe = {
  invite(params) {
    return ApiService.post(`guest/v2/create/`, params, { useError: false })
  },
  /** 所有服务类型 + 服务 */
  async allService() {
    /* [ { id, name, extras: [{ fieldName, fieldType, fieldMsg}] }] */
    const { success, data } = await ApiService.query(`guest/v2/type/all/`)
    if (success) {
      const requests = data.map((type) => {
        const { id } = type
        /* [ { id, name, supplierName, supplierAddress, linkman, linkmanPhone, pics: [], memo }] */
        return ApiService.query(`guest/v2/service/all/`, { typeId: id }).then(
          (res) => {
            const { success, data } = res
            return success ? { type, data } : { type }
          }
        )
      })
      return Promise.all(requests)
    } else {
      return { data: [] }
    }
  },
  /** 短信验证码 */
  sendCode(phone) {
    return ApiService.post(`guest/v2/sendCode/`, { phone })
  },
  /** 短信验证码登录 */
  codeLogin(phone, code) {
    return ApiService.post(`guest/v2/login/`, { phone, code })
  },
  /** 申请服务 */
  apply(services) {
    /** services: [ { serviceId, extraInfo } ] */
    return ApiService.post(`guest/v2/apply/`, { services })
  },
  applyDetails(itemId) {
    return ApiService.query(`guest/v2/apply/detail/`, { id: itemId })
  },
  guestInfo() {
    return ApiService.query(`guest/v2/detail/`)
  },
  guestUpdate(params) {
    return ApiService.post(`guest/v2/update/`, params)
  },
  guestServiceHistory(params) {
    return ApiService.post(`guest/v2/apply/history/`, params)
  }
}
